import React, { useState, useEffect, useRef  } from "react";
import SelectField from "../../../../components/ui/basicSelectInput";
import { Grid, Box } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";

import Modal from "react-bootstrap/Modal";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Tooltip from "@mui/material/Tooltip";
import excelIconImage from '../../../../asserts/images/excelicon.svg';
import { CircularProgress, Alert, Snackbar } from "@mui/material";
import axios from "../../../../axios-order";
import { useHistory } from 'react-router-dom';



export default function IMSOutwardReconciliation() {
    const history = useHistory();
    const formRef = useRef(null);
    const [yearFromArr, setFromYearArr] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [monthsArrau, setMonthsArray] = useState("")
    const [selectedFromMonth, setSelectedFromMonth] = useState("");
    const [selectedReturnType, setselectedReturnType] = useState("");
    const [recordForLogTable, setrecordForLogTable] = useState("");
    const [loaderForTable, setloaderForTable] = useState("");
    const [modalShow, setmodalShow] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });

    const monthArray = [
        { id: 4, value: "April" },
        { id: 5, value: "May" },
        { id: 6, value: "June" },
        { id: 7, value: "July" },
        { id: 8, value: "August" },
        { id: 9, value: "September" },
        { id: 10, value: "October" },
        { id: 11, value: "November" },
        { id: 12, value: "December" },
        { id: 1, value: "January" },
        { id: 2, value: "February" },
        { id: 3, value: "March" },
    ];


    const returnType = [
        { id: 1, value: "GSTR-1/FF" },
        { id: 2, value: "GSTR-1A" },
    ]


    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleFromMonthChange = (e) => {
        setSelectedFromMonth(e.target.value);
    };

    const handleReturnTypeChange = (e) => {
        setselectedReturnType(e.target.value);
    };

    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 5; i <= current_year; i++) {
            const toYear = String(i + 1)
            yearArr.push({ id: i, year: `${i}-${toYear.slice(2)}` });
        }
        setFromYearArr(yearArr);
    };

    const handleSubmit = () => {
        const formData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            financial_year: selectedYear,
            return_period: selectedFromMonth,
            return_type: selectedReturnType,
        };

        axios.post("/ims_outward_recon_api", formData)
            .then(response => {
                // Always check the actual response structure
                const res = response.data;

                if (res.status === true || res.status === "true") {
                    setSnackbar({
                        open: true,
                        message: res.message || "Success!",
                        severity: 'success',
                    });
                } else {
                    // This will now correctly show your error message
                    setSnackbar({
                        open: true,
                        message: res.message || "Something went wrong.",
                        severity: 'error',
                    });
                }


            }

            )
            .catch(error => {
                // Properly handle network or server errors
                let errorMessage = "Network error. Please try again.";

                if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                setSnackbar({
                    open: true,
                    message: errorMessage,
                    severity: 'error',  // Fixed: was incorrectly set to 'success'
                });
            });
        getLogTable();
        setmodalShow(false);
        resetFormFields();

        console.log("Submitted Values:", formData);
    };

    const getLogTable = () => {
        setloaderForTable(true); // optional: show loading state

        axios
            .get(`/ims_outward_recon_summary/${localStorage.getItem("business_entity_id")}`)
            .then((response) => {
                console.log('Log table API response:', response.data);

                const records = response?.data?.data || response?.data || [];

                setrecordForLogTable(records);
                setloaderForTable(false);
            })
            .catch((error) => {
                console.error('Error fetching log table:', error);
                setrecordForLogTable([]); // ensure it's always an array
                setloaderForTable(false);
            });
    };

    useEffect(() => {
        setFromYearValues()
        getLogTable()
    }, []);


    const handleModalClose = () => {
        setmodalShow(false)

    }

    const onClickRunIms = () => {
        setmodalShow(true)
    }

      const resetFormFields = () => {
        setSelectedYear("");
        setSelectedFromMonth("");
        setselectedReturnType("");
        
        // Reset form validation
        if (formRef.current) {
            formRef.current.resetValidations();
        }
    };

    const handleViewReport = (v) => {
        const reconId = v.ims_outward_recon_id;
        localStorage.setItem("ims_recon_id", reconId);
        if (v.status === "Pass") {
            history.push(`/IMSOutwardReconciliation_data/${reconId}`);
        }
        else {
            setSnackbar({
                open: true,
                message: v.remarks,
                severity: 'warning'
            });
        }


    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleDownloadExcel = (ims_outward_recon_id) => {
        const payload = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            ims_outward_recon_id: ims_outward_recon_id
        }
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `IMS Outward.xlsx`;

        axios
            .post(`/ims_outward_excel_api`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                ims_outward_recon_id: ims_outward_recon_id,
                // payload,
                extension: "xlsx",
            })
            .then((res) => {
                if (res.data.status === "pass") {
                    downloadBase64File(contentType, res.data.file, filename);
                } else {
                    // setSnackbar({
                    //     open: true,
                    //     message: "Unable to download!",
                    //     severity: 'error'
                    // });
                }
            })
            .catch((error) => {
                // setSnackbar({
                //     open: true,
                //     message: "Server Error, Try After Some Time",
                //     severity: 'error'
                // });
            });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

            <>
                <button
                    className="button-outlined-primary"
                    style={{ marginLeft: "0px", width: "15%" }}
                    onClick={onClickRunIms}
                >
                    RUN IMS OUTWARD RECON
                </button>

                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={modalShow}
                    onHide={handleModalClose}
                    dialogClassName="modal-90w"
                    style={{ maxWidth: "none" }}
                >
                    <Modal.Header closeButton className="modal-header">
                        <Modal.Title className="modal-title">
                            Run IMS Outward Reconciliation
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "30px" }}>
                        <ValidatorForm>
                            <Grid container spacing={3} alignItems="flex-end">
                                {/* ---- FIRST SELECT ---- */}
                                <Grid item xs={12} sm={4}>
                                    <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                            <label
                                                style={{
                                                    fontSize: "14px",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Select Financial Year <span style={{ color: "red" }}>*</span>:
                                            </label>
                                        </Grid>
                                        <Grid item>
                                            <SelectField
                                                validator={["required"]}
                                                errorMsg={["This field is required"]}
                                                choice_id="year"
                                                choice_name="year"
                                                name="year1"
                                                choices={yearFromArr}
                                                value={selectedYear}
                                                onChange={handleYearChange}
                                                style={{ width: "100%" }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* ---- SECOND SELECT ---- */}
                                <Grid item xs={12} sm={4}>
                                    <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                            <label
                                                style={{
                                                    fontSize: "14px",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Return Period <span style={{ color: "red" }}>*</span>:
                                            </label>
                                        </Grid>
                                        <Grid item>
                                            <SelectField
                                                validator={["required"]}
                                                errorMsg={["This field is required"]}
                                                choice_id="value"
                                                choice_name="value"
                                                name="month"
                                                value={selectedFromMonth}
                                                onChange={handleFromMonthChange}
                                                choices={monthArray}
                                                style={{ width: "100%" }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* ---- THIRD SELECT ---- */}
                                <Grid item xs={12} sm={4}>
                                    <Grid container direction="column" spacing={0}>
                                        <Grid item>
                                            <label
                                                style={{
                                                    fontSize: "14px",
                                                    marginBottom: "8px",
                                                    display: "block",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Return Type <span style={{ color: "red" }}>*</span>:
                                            </label>
                                        </Grid>
                                        <Grid item>
                                            <SelectField
                                                validator={["required"]}
                                                errorMsg={["This field is required"]}
                                                choice_id="value"
                                                choice_name="value"
                                                name="return_type"
                                                choices={returnType}
                                                value={selectedReturnType}
                                                onChange={handleReturnTypeChange}
                                                style={{ width: "100%" }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* ---- SUBMIT & CANCEL BUTTONS ---- */}
                                <Grid item xs={12} style={{ marginTop: "20px" }}>
                                    <Grid container spacing={2} justifyContent="flex-end">
                                        <Grid item xs={12} sm={2}>
                                            <button
                                                type="button"
                                                className="button-outlined-primary"
                                                style={{
                                                    width: "100%",
                                                    height: "40px",
                                                    fontSize: "14px",
                                                    padding: "0 16px",
                                                }}
                                                onClick={handleModalClose}
                                            >
                                                Cancel
                                            </button>
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <button
                                                type="submit"
                                                className="button-outlined-primary"
                                                style={{
                                                    width: "100%",
                                                    height: "40px",
                                                    fontSize: "14px",
                                                    padding: "0 16px",
                                                }}
                                                onClick={handleSubmit}
                                            >
                                                Submit
                                            </button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Modal.Body>
                </Modal>

                <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                    <BoxWrapper
                        boxTitle="IMS Reconciliation"
                        addButtonLabel="Refresh"
                        enableAddButton={true}
                        // addButtonLabel="Refresh"
                        addButtonHandlerFn={getLogTable}
                    >
                        <div style={{
                            maxHeight: "400px", // Set max height for vertical scrolling
                            overflowY: "auto", // Enable vertical scrolling
                            overflowX: "auto", // Enable horizontal scrolling
                            width: "100%", // Ensure the div takes full width
                        }} >
                            <table className="custome-table">
                                <thead>
                                    <tr>
                                        <th>Financial Year</th>
                                        <th>Return Period</th>
                                        <th>Status</th>
                                        <th>Uploaded Date Time</th>
                                        <th>Modified Date Time</th>
                                        {/* <th>Remark</th> */}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loaderForTable ? (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                                                <CircularProgress size={24} style={{ marginRight: 10 }} />
                                                Loading… Please wait
                                            </td>
                                        </tr>
                                    ) : Array.isArray(recordForLogTable) && recordForLogTable.length > 0 ? (
                                        recordForLogTable.map((v, index) => (
                                            <tr key={v.id || index}> {/* fallback to index if no id */}
                                                <td>{v.financial_year}</td>
                                                <td>{v.return_period}</td>
                                                <td>
                                                    <span style={{
                                                        padding: "4px 12px",
                                                        borderRadius: "4px",
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        backgroundColor:
                                                            v.status === "Pass" ? "#e8f5e9" :
                                                                v.status === "Failed" ? "#ffebee" :
                                                                    v.status === "In Progress" ? "#fff3e0" : "#f5f5f5",
                                                        color:
                                                            v.status === "Pass" ? "#2e7d32" :
                                                                v.status === "Failed" ? "#c62828" :
                                                                    v.status === "In Progress" ? "#ef6c00" : "#424242"
                                                    }}>
                                                        {v.status || "Unknown"}
                                                    </span>
                                                </td>
                                                <td>{v.uploaded_datetime || "-"}</td>
                                                <td>{v.modified_datetime || "-"}</td>
                                                {/* <td>{v.remarks || "-"}</td> */}
                                                <td>
                                                    <Tooltip title="View Report">
                                                        <VisibilityOutlinedIcon
                                                            onClick={() => handleViewReport(v)} // you'll define this
                                                            style={{ cursor: "pointer", color: "#1976d2", fontSize: 20 }}
                                                        />
                                                    </Tooltip>

                                                    <Tooltip title="Download Excel">
                                                        <img
                                                            onClick={v.status === "Pass" ? () => handleDownloadExcel(v.ims_outward_recon_id) : null}
                                                            style={{
                                                                marginLeft: "10px",
                                                                height: "23px",
                                                                width: "25px",
                                                                cursor: "pointer",
                                                                opacity: v.status === "Pass" ? 1 : 0.5,
                                                                cursor: v.status === "Pass" ? "pointer" : "not-allowed",
                                                            }}
                                                            src={excelIconImage}
                                                            alt="Download Excel"
                                                        />
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: "center", color: "#999", padding: "40px" }}>
                                                No Data Found!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </BoxWrapper>
                </div>
            </>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </div>

    );
}